import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PatientAddPage } from './patient-add';
import { ComponentsModule } from '../../components/components.module';
import { MatDatepickerModule }  from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule  }  from '@angular/material';

@NgModule({
  declarations: [
    PatientAddPage,
  ],
  imports: [
    IonicPageModule.forChild(PatientAddPage),
    ComponentsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule
  ],
})
export class PatientAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/patient-add/patient-add.module.ts